import React, { Component, Fragment } from "react";
import {Rule} from "../../models/mailroom-school-config-rules/Rule";
import {ConfigDropdown} from "./ConfigDropdown";
import {MailroomSchoolConfig} from "../../models/MailroomSchoolConfig";
import {AadJoinConfig} from "../../models/AadJoinConfig";
import {MessageBar, MessageBarType, TextField, Toggle} from "office-ui-fabric-react";
import {AadJoinTargetOption} from "../../models/mailroom-keyed-options/AadJoinTargetOption";
import {AadJoinSourceOption} from "../../models/mailroom-keyed-options/AadJoinSourceOption";


export interface AadJoinConfigEditorProps {
    userNoun: "Teacher" | "Student";
    path: string;
    configRules: Rule[];
    config: MailroomSchoolConfig;
    
    aadJoinConfigChanged: (newConfig: AadJoinConfig) => void;
}

export interface AadJoinConfigEditorState {
    
}

export class AadJoinConfigEditor extends Component<AadJoinConfigEditorProps, AadJoinConfigEditorState> {

    constructor(props: AadJoinConfigEditorProps) {
        super(props);

        this.state = {
        };
    }

    public async componentDidMount() {
    }

    public componentDidUpdate(prevProps: Readonly<AadJoinConfigEditorProps>, prevState: Readonly<AadJoinConfigEditorState>, snapshot?: any) {
        
        
    }
    
    private patchConfig(patch: Partial<AadJoinConfig>): void {
        const existingConfig = this.props.config[this.props.path] as AadJoinConfig;
        const newConfig = Object.assign({},existingConfig,patch) as AadJoinConfig;
        
        if(newConfig.sourceAddSchoolCodePrefix == null)
        {
            //todo: better defaults for join config (once it has been turned on in options)
            newConfig.sourceAddSchoolCodePrefix = false;
        }
        
        this.props.aadJoinConfigChanged(newConfig);
    }
    
    public render() {
        
        var joinConfig = this.props.config[this.props.path] as AadJoinConfig;
        return (
            <Fragment>
                <div className={"aad-join-config-editor"}>
                    <h4>{this.props.userNoun} AAD Email Lookup</h4>

                    <MessageBar messageBarType={MessageBarType.warning}>
                        Only use this if the MIS does not contain {this.props.userNoun.toLowerCase()} email addresses and they can not be added.
                    </MessageBar>
                    
                    
                    <div className={"aad-join-config-editor__content"}>
                        <div className={"aad-join-config-editor__formula"}>

                            <div className={"flex-row flex--align-items-center"}>
                                <Toggle
                                    inlineLabel={false}
                                    checked={joinConfig.sourceAddSchoolCodePrefix!}
                                    onChange={(event, newValue) => {
                                        this.patchConfig({
                                            sourceAddSchoolCodePrefix: newValue
                                        });
                                    }}
                                    role="switch"
                                    label={"School Code"}
                                />

                                <span className={"aad-join-config-editor__formula-symbol"}>+</span>


                                <TextField
                                    label={"Prefix"}
                                    value={joinConfig.sourcePrefix!}
                                    onChange={(event,newValue) => {
                                        this.patchConfig({sourcePrefix: newValue})
                                    }}
                                >
                                </TextField>

                                <span className={"aad-join-config-editor__formula-symbol"}>+</span>


                                <ConfigDropdown
                                    path={[this.props.path, "source"]}
                                    config={this.props.config}
                                    configRules={this.props.configRules}
                                    selectedKey={joinConfig.source!}
                                    label="Value from MIS user"
                                    onChange={(key) => {
                                        this.patchConfig({source: key as AadJoinSourceOption})
                                    }} />
                                
                            </div>

                            <span className={"aad-join-config-editor__formula-symbol"}>=</span>

                            <ConfigDropdown
                                path={[this.props.path, "target"]}
                                config={this.props.config}
                                configRules={this.props.configRules}
                                selectedKey={joinConfig.target!}
                                label="Value in AAD User"
                                onChange={(key) => {
                                    this.patchConfig({target: key as AadJoinTargetOption})
                                }} />
                        </div>
                    </div>
                    
                    
                </div>
            </Fragment>
        );
    }
}